export default __webpack_public_path__ + "static/media/bitbucket.43a52fe9.svg";